<script>
import {Bar} from "vue-chartjs";
import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

Chart.plugins.register(ChartDataLabels);

// Browsers leave a canvas blank once it passes their size limit: Chrome ~32,767px
// per side, iOS Safari ~16.7M pixels in total. One bar per branch (~800) at a
// phone's pixel ratio of 3 is ~73,000px wide, so cap the ratio to fit.
const MAX_CANVAS_SIDE = 32767;
const MAX_CANVAS_AREA = 16777216;

export default {
  extends: Bar,
  props: ['chartData', 'report_type'],
  methods: {
    safePixelRatio() {
      const ratio = window.devicePixelRatio || 1;
      const width = this.$el.clientWidth || 1;
      const height = this.$el.clientHeight || 1;
      return Math.min(ratio, MAX_CANVAS_SIDE / width, MAX_CANVAS_SIDE / height,
          Math.sqrt(MAX_CANVAS_AREA / (width * height)));
    }
  },
  mounted() {
    let message = '';
    if (this.report_type === 'shipment' || this.report_type === 'cod') {
      message = ' ' + this.$t('chart.bills_unit')
    } else {
      message = ' ' + this.$t('chart.kip_unit')
    }
    this.renderChart({
      labels: this.chartData.labels,
      datasets: [
        {
          label: (this.report_type === 'shipment' || this.report_type === 'cod') ? this.$t('chart.bills_count') : (this.report_type === 'freight') ? this.$t('chart.freight') : this.$t('chart.goods_price'),
          backgroundColor: (this.report_type === 'shipment' || this.report_type === 'cod') ? '#E11F26' : (this.report_type === 'freight') ? '#2EA8D9' : '#F6CA07',
          data: (this.report_type === 'shipment' || this.report_type === 'cod') ? this.chartData.qty : (this.report_type === 'freight') ? this.chartData.freight : this.chartData.price,
        },
      ]
    }, {
      responsive: true,
      maintainAspectRatio: false,
      devicePixelRatio: this.safePixelRatio(),
      scales: {
        yAxes: [{
          ticks: {
            callback: (value) => {
              const p = value.toFixed(2).split(".");
              return p[0].split("").reverse().reduce(function (acc, value, i) {
                return value === "-" ? acc : value + (i && !(i % 3) ? "," : "") + acc;
              }, "") + message;
            },
            fontColor: 'black',
            fontFamily: 'Phetsarath OT',
            fontSize: 10
          },
        }],
        xAxes: [{
          ticks: {
            fontColor: 'black',
            fontFamily: 'Phetsarath OT',
            fontSize: 10,
            maxRotation: 90,
            minRotation: 90,
            autoSkip: false,
            autoSkipPadding: 15,
          },
        }]
      },
      tooltips: {
        enabled: true,
        callbacks: {
          label: ((tooltipItems) => {
            let p = tooltipItems.yLabel.toFixed(2).split(".");
            return p[0].split("").reverse().reduce(function (acc, value, i) {
              return value === "-" ? acc : value + (i && !(i % 3) ? "," : "") + acc;
            }, "") + message
          })
        },
        titleFontFamily: 'Phetsarath OT',
        footerFontFamily: 'Phetsarath OT',
        bodyFontFamily: 'Phetsarath OT',
      },
      legend: {
        display: false,
      },
      plugins: {
        datalabels: {
          formatter: function (value) {
            let p = value.toFixed(2).split(".");
            return p[0].split("").reverse().reduce(function (acc, value, i) {
              return value === "-" ? acc : value + (i && !(i % 3) ? "," : "") + acc;
            }, "")
          },
          color: "black",
          align: "top",
          offset: 0,
          rotation: -90,
          anchor: "end",
          font: {
            size: 10,
            family: 'Phetsarath OT'
          }
        }
      }
    })
  }
}
</script>

<style scoped>

</style>
